import Vue from 'vue';
import { ls } from '@utils/local-storage-ttl';
import Register from '@/src/models/Register';

export const state = {
  authenticated: false,
  user: null,
};

export const mutations = {
  CHECK(state) {
    try {
      state.authenticated = !!ls.get('id_token');

      if (ls.get('user')) {
        state.user = JSON.parse(ls.get('user'));
      }

      if (state.authenticated) {
        Vue.axios.defaults.headers.common.Authorization = `Bearer ${ls.get('id_token')}`;
      } else {
        // remove because of ttl expired
        localStorageClean(state);
      }
    } catch (err) {
      // remove because of parsing error
      localStorageClean(state);
    }
  },
  USER(state, payload) {
    state.user = payload;
    ls.set('user', JSON.stringify(payload), payload.ttl);
  },
  LOGIN(state, payload) {
    state.authenticated = true;
    state.user = payload.user;
    ls.set('id_token', payload.token, payload.ttl);
    ls.set('user', JSON.stringify(payload.user), payload.ttl);
    Vue.axios.defaults.headers.common.Authorization = `Bearer ${payload.token}`;
  },
  LOGOUT(state, router) {
    localStorageClean(state);
    router.push({
      name: 'login.index',
    });
  },
};

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return state.authenticated;
  },
};

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    // dispatch('check')
  },

  check({ commit }) {
    commit('CHECK');
  },

  // Logs in the current user.
  async login({ commit, dispatch }, payload) {
    await Vue.$auth
      .login(payload.user)
      .then((response) => {
        commit('LOGIN', response.data);
        dispatch('notifications/fetchNotifications', null, { root: true });
        if (payload.successCallback) payload.successCallback();
        if (payload.redirect) {
          payload.router.push({
            name: payload.redirect,
          });
        }
      })
      .catch(() => payload.callback());
    payload.callback();
  },

  // Logs out the current user.
  logout({ commit, dispatch }, payload) {
    dispatch('notifications/resetNotifications', null, { root: true });
    if (!payload.loggedOut) {
      Vue.axios.post('auth/logout').then(() => {
        commit('LOGOUT', payload.router);
      });
    } else {
      commit('LOGOUT', payload.router);
    }
  },

  async register({ commit }, payload) {
    await new Register(payload.user)
      .save()
      .then((response) => {
        if (payload.successCallback) payload.successCallback(response.data);
        if (payload.redirect) {
          payload.router.push({
            name: payload.redirect,
          });
        }
      })
      .catch(() => payload.callback());
    // await Vue.$auth
    //   .register(payload.user)
    //   .then((response) => {
    //     if (payload.successCallback) payload.successCallback(response.data);
    //     if (payload.redirect) {
    //       payload.router.push({
    //         name: payload.redirect,
    //       });
    //     }
    //   })
    //   .catch(() => payload.callback());
    payload.callback();
  },
};

// ===
// Private helpers
// ===

function localStorageClean(state) {
  state.authenticated = false;
  state.user = {};
  localStorage.removeItem('id_token');
  localStorage.removeItem('user');
  localStorage.removeItem('vue-authenticate.vueauth_token');
  Vue.axios.defaults.headers.common.Authorization = '';
}
